<script setup lang="ts"></script>

<template>
  <div class="ApplicationSectionComponent">
    <div class="ApplicationSectionHeader">
      <slot name="header">Header</slot>
    </div>
    <div class="ApplicationSectionStatus">
      <slot name="status">Status</slot>
    </div>

    <div class="ApplicationSectionButtonContainer">
      <slot name="button">
        <el-button type="primary"> Button </el-button>
      </slot>
    </div>
  </div>
</template>

<style lang="less" scoped>
.ApplicationSectionComponent {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 1rem 1.5rem;
  align-items: center;
  border-radius: 5px;
  border: 1px solid var(--el-color-primary-light-5);
  color: black;
  font-size: 0.93em;

  background-color: white;

  .ApplicationSectionHeader {
    font-weight: 500;
    font-size: 1.25em;
    display: flex;
    flex-direction: column;
  }

  .ApplicationSectionStatus {
    justify-self: center;
    font-size: 1.1em;

    display: flex;
    flex-direction: column;
    align-items: center;
    .Instructions {
      font-size: 0.8em;
    }
  }

  .ApplicationSectionButtonContainer {
    width: min-content;
    justify-self: flex-end;

    display: flex;
    justify-content: flex-end;
  }
}
</style>
